// extracted by mini-css-extract-plugin
export default {"wrapper":"SuccessCallback_wrapper__G7ATr","container":"SuccessCallback_container__4FR0i","thanks":"SuccessCallback_thanks__d0gD2"};